// 大盘/行业/行业详情三个页面共用的通用 UI 脚手架，原先都挤在 MarketObservation.jsx 里。
// 三个模块的 styles 合并方式与主文件保持一致，保证被移动组件用到的 class 解析结果不变。
import React from "react";
import { ArrowLeft, Database, RefreshCw } from "lucide-react";

import { StatusBadge } from "./MarketAtoms";
import baseStyles from "./marketObservation.module.css";
import overviewStyles from "./marketOverview.module.css";
import tableStyles from "./marketTables.module.css";

const styles = { ...baseStyles, ...overviewStyles, ...tableStyles };

export function LoadingState({ label = "正在读取真实市场数据", compact = false, detail = "数据只读自本地市场库，不使用演示行情。" }) {
  return (
    <div className={`${styles.statePanel} ${compact ? styles.compactStatePanel : ""}`} role="status">
      <RefreshCw className={styles.spin} size={22} />
      <strong>{label}</strong>
      <span>{detail}</span>
    </div>
  );
}

export function ErrorState({ error, onRetry }) {
  return (
    <div className={styles.statePanel} role="alert">
      <Database size={22} />
      <strong>市场数据暂时无法读取</strong>
      <span>{error || "请检查本地市场库状态。"}</span>
      <button className={styles.primaryButton} onClick={onRetry}>重新读取</button>
    </div>
  );
}

export function Unavailable({ reason }) {
  return <div className={styles.unavailable}><Database size={18} /><span>{reason}</span></div>;
}

export function PageHeading({ eyebrow, title, description, actions, status, dataDate, backAction }) {
  return (
    <div className={styles.pageHeading}>
      <div className={styles.headingCopy}>
        {backAction && <button className={styles.backButton} onClick={backAction}><ArrowLeft size={16} />返回板块</button>}
        <span className={styles.eyebrow}>{eyebrow}</span>
        <h1>{title}</h1>
        <p>{description}</p>
        <StatusBadge status={status} dataDate={dataDate} styles={styles} />
      </div>
      <div className={styles.headingActions}>{actions}</div>
    </div>
  );
}

export function SectionTitle({ icon, title, meta, action }) {
  return (
    <div className={styles.sectionTitle}>
      <div>{icon}<strong>{title}</strong>{meta && <span>{meta}</span>}</div>
      {action}
    </div>
  );
}

export function EvidenceFooter({ payload }) {
  return (
    <footer className={styles.evidenceFooter}>
      <Database size={15} />
      <span>数据源 {payload.source}</span>
      <span>数据日期 {payload.data_date ?? "--"}</span>
      <span>证据 {payload.evidence_refs?.join(" · ")}</span>
    </footer>
  );
}
